export interface RouteConfig {
  path: string;
  requiresAuth?: boolean;
  allowedRoles?: Array<'ADMIN' | 'CASHIER'>;
  component: () => Promise<{ default: React.ComponentType<any> }>;
}

export interface ModuleRouteConfig {
  id: string;
  routes?: RouteConfig[];
}

// Route definitions - components will be lazy loaded in AppRoutes
export const routesConfig: ModuleRouteConfig[] = [
  {
    id: 'auth',
    routes: [
      {
        path: '/sign-in',
        component: () => import('@/app/modules/auth/pages/SignInPage'),
        requiresAuth: false,
      },
    ],
  },
  {
    id: 'accounting',
    routes: [
      {
        path: '/dashboard',
        component: () => import('@/app/modules/dashboard/pages/DashboardPage'),
        requiresAuth: true,
      },
      {
        path: '/accounts',
        component: () => import('@/app/modules/account/pages/AccountListPage'),
        requiresAuth: true,
      },
      {
        path: '/accounts/:id/balances',
        component: () => import('@/app/modules/account/pages/AccountBalancesPage'),
        requiresAuth: true,
      },
      {
        path: '/accounts/:id/balance-transactions/new',
        component: () =>
          import(
            '@/app/modules/account-balance-transaction/pages/AccountBalanceTransactionFormPage'
          ),
        requiresAuth: true,
        allowedRoles: ['ADMIN'],
      },
      {
        path: '/currencies',
        component: () => import('@/app/modules/currency/pages/CurrencyListPage'),
        requiresAuth: true,
      },
      {
        path: '/expenses',
        component: () => import('@/app/modules/expense/pages/ExpenseLedgersPage'),
        requiresAuth: true,
      },
      {
        path: '/expenses/:ledgerId',
        component: () =>
          import('@/app/modules/expense/pages/ExpenseLedgerDetailPage'),
        requiresAuth: true,
      },
      {
        path: '/revenues',
        component: () => import('@/app/modules/revenue/pages/RevenueLedgersPage'),
        requiresAuth: true,
      },
      {
        path: '/revenues/:ledgerId',
        component: () =>
          import('@/app/modules/revenue/pages/RevenueLedgerDetailPage'),
        requiresAuth: true,
      },
      {
        path: '/users',
        component: () => import('@/app/modules/auth/pages/UsersManagementPage'),
        requiresAuth: true,
        allowedRoles: ['ADMIN'],
      },
      {
        path: '/profile',
        component: () => import('@/app/modules/auth/pages/ProfileManagementPage'),
        requiresAuth: true,
      },
      {
        path: '/reports/account-summary',
        component: () => import('@/app/modules/report/pages/BalanceReportPage'),
        requiresAuth: true,
      },
    ],
  },
  {
    id: 'ledgers',
    routes: [
      {
        path: '/ledgers',
        component: () => import('@/app/modules/global-ledger/pages/LedgersPage'),
        requiresAuth: true,
      },
      {
        path: '/ledgers/rollover',
        component: () => import('@/app/modules/global-ledger/pages/RolloverPage'),
        requiresAuth: true,
        allowedRoles: ['ADMIN'],
      },
      {
        path: '/ledgers/:id',
        component: () =>
          import('@/app/modules/global-ledger/pages/LedgerDetailsPage'),
        requiresAuth: true,
      },
    ],
  },
  {
    id: 'admin',
    routes: [
      {
        path: '/admin/backup',
        component: () => import('@/app/modules/backup/pages/BackupPage'),
        requiresAuth: true,
        allowedRoles: ['ADMIN'],
      },
    ],
  },
];
